import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
import Swal from 'sweetalert2';
import Systems from "./SystemFunction";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            prolistx: [],
            username: null,
            userid: null,
            showmodal: false,
            prodetail: null,
            proderedeem: [],
            activeRedeem: [],
            loadingcancelpromotion: false,
            picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",

            activeTab: "สมาชิกใหม่",
            loginstate: false,
            alert: null,
            loading: false,

            couponCode: '',
            loadingCoupon: false
        };
    }

    async componentDidMount() {
        this.checklogin();
        this.promotionlist();
        this.getredeempromotion();
        this._onPopState = () => this.openPromotionFromUrl(true);
        window.addEventListener('popstate', this._onPopState);
    }

    // ดึงโปรที่ผู้ใช้กำลังรับอยู่ (เก็บใน activeRedeem แยกจาก proderedeem ของ popup)
    getredeempromotion = async () => {
        const token = localStorage.getItem('auth_token');
        if (!token) return;

        try {
            const decoded = jwt_decode(token);
            const Username = decoded.message.playerid;

            const res = await instance.post("/api/v1/getredeempromotion", {
                userid: Username,
                System: Systems
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            // status 200 = มีโปร active, 201 = "No active promotion found" (tblpromotionredeems ว่าง)
            const redeems = res.data?.message?.tblpromotionredeems;
            this.setState({
                activeRedeem: Array.isArray(redeems) ? redeems : []
            });
        } catch (err) {}
    };

    // ยกเลิกโปรที่กำลังรับอยู่
    cancelPromotion = async (e) => {
        try {
            if (e) e.preventDefault();

            const current = (this.state.activeRedeem && this.state.activeRedeem.length > 0)
                ? this.state.activeRedeem[0]
                : null;

            if (!current) {
                await Swal.fire({
                    icon: 'warning',
                    title: 'ไม่พบโปรโมชั่น',
                    text: 'ไม่มีโปรโมชั่นที่กำลังใช้งานอยู่',
                    confirmButtonText: 'ตกลง'
                });
                return;
            }

            const confirm = await Swal.fire({
                title: 'ยกเลิกโปรโมชั่น?',
                text: 'คุณต้องการยกเลิกโปรโมชั่นปัจจุบันหรือไม่',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ปิด',
                reverseButtons: true
            });

            if (!confirm.isConfirmed) return;

            const token = localStorage.getItem('auth_token');

            if (!token) {
                await Swal.fire({
                    icon: 'error',
                    title: 'Session หมดอายุ',
                    text: 'กรุณาเข้าสู่ระบบใหม่',
                    confirmButtonText: 'ตกลง'
                });
                return;
            }

            const decoded = jwt_decode(token);
            const Username = decoded.message.playerid;

            this.setState({ loadingcancelpromotion: true });

            const res = await instance.post('/api/v1/usercancelpromotion', {
                User_id: Username,
                System: Systems,
                no: current.redeemno || current.no
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (res.data.status === 200) {
                this.setState({ activeRedeem: [], loadingcancelpromotion: false });

                await Swal.fire({
                    icon: 'success',
                    title: 'สำเร็จ',
                    text: 'ยกเลิกโปรโมชั่นเรียบร้อย',
                    confirmButtonText: 'ตกลง'
                });

                this.getredeempromotion();
                return;
            }

            this.setState({ loadingcancelpromotion: false });

            await Swal.fire({
                icon: 'error',
                title: 'ไม่สำเร็จ',
                text: res.data.message || 'ไม่สามารถยกเลิกโปรโมชั่นได้',
                confirmButtonText: 'ตกลง'
            });
        } catch (error) {
            this.setState({ loadingcancelpromotion: false });

            await Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: error?.message || 'ไม่สามารถยกเลิกโปรโมชั่นได้',
                confirmButtonText: 'ตกลง'
            });
        }
    };

    // กล่องโชว์โปรที่กำลังรับ + ปุ่มยกเลิก (ใช้ทั้ง desktop และ mobile)
    renderActivePromotion = () => {
        if (!this.state.loginstate) return null;

        const active = (this.state.activeRedeem && this.state.activeRedeem.length > 0)
            ? this.state.activeRedeem[0]
            : null;

        return (
            <div className="promo-active-section">
                {active ? (
                    <div className="promo-active-card">
                        <div className="promo-active-left">
                            <div className="promo-active-icon">🎁</div>
                            <div className="promo-active-info">
                                <div className="promo-active-label">กำลังรับโปรโมชั่นอยู่</div>
                                <div className="promo-active-name">
                                    {active.proname || active.promotionname || 'โปรโมชั่นปัจจุบัน'}
                                </div>
                                <div className="promo-active-sub">โปรโมชั่นจะเข้าอัตโนมัติเมื่อเติมเงิน</div>
                            </div>
                        </div>
                        <button
                            className="promo-active-cancel"
                            disabled={this.state.loadingcancelpromotion}
                            onClick={this.cancelPromotion}
                        >
                            {this.state.loadingcancelpromotion ? 'กำลังยกเลิก...' : '✕ ยกเลิกโปรโมชั่น'}
                        </button>
                    </div>
                ) : (
                    <div className="promo-active-empty">
                        <div className="promo-active-icon">🎉</div>
                        <div className="promo-active-info">
                            <div className="promo-active-label">ไม่มีการรับโปรโมชั่น</div>
                            <div className="promo-active-sub">สามารถเลือกโปรโมชั่นด้านล่างได้เลย</div>
                        </div>
                    </div>
                )}

                <style>{`
                    .promo-active-section { margin: 0 0 14px; }
                    .promo-active-card { display: flex; align-items: center; justify-content: space-between; gap: 12px; background: #fff; border: 1px solid #ffe2bd; border-left: 4px solid #ff8a00; border-radius: 12px; padding: 12px 14px; box-shadow: 0 2px 8px rgba(0,0,0,.06); }
                    .promo-active-left { display: flex; align-items: center; gap: 12px; min-width: 0; }
                    .promo-active-icon { font-size: 26px; line-height: 1; flex: 0 0 auto; }
                    .promo-active-info { min-width: 0; }
                    .promo-active-label { color: #ff8a00; font-weight: 700; font-size: 13px; }
                    .promo-active-name { color: #1a1a1a; font-weight: 700; font-size: 15px; margin: 2px 0; word-break: break-word; }
                    .promo-active-sub { color: #8697a2; font-size: 12px; }
                    .promo-active-cancel { flex: 0 0 auto; background: #fff; color: #e23b3b; border: 1px solid #f3b4b4; border-radius: 8px; padding: 8px 12px; font-size: 13px; font-weight: 700; cursor: pointer; white-space: nowrap; }
                    .promo-active-cancel:hover { background: #fff0f0; }
                    .promo-active-cancel:disabled { opacity: .6; cursor: not-allowed; }
                    .promo-active-empty { display: flex; align-items: center; gap: 12px; background: #fff; border: 1px dashed #d9dee3; border-radius: 12px; padding: 12px 14px; }
                    @media (max-width: 760px) {
                        .promo-active-card { flex-direction: column; align-items: stretch; }
                        .promo-active-cancel { width: 100%; padding: 10px; }
                    }
                `}</style>
            </div>
        );
    };

    componentWillUnmount() {
        if (this._onPopState) {
            window.removeEventListener('popstate', this._onPopState);
        }
    }

    openPromotionFromUrl = (fromPop) => {
        try {
            const url = new URL(window.location.href);
            const promoId = url.searchParams.get('promoId');

            if (!promoId) {
                if (fromPop && this.state.showmodal) {
                    this.setState({ showmodal: false, prodetail: null, proderedeem: [] });
                }
                return;
            }

            const item = (this.state.prolistx || []).find(
                (p) => String(this.getPromotionUrlId(p)) === String(promoId)
            );

            if (item) {
                this.setState({ showmodal: true, prodetail: item, proderedeem: [] });
            }
        } catch (err) {}
    };

    checklogin = () => {
        var token = localStorage.getItem('auth_token');

        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;

            this.setState({
                username: Username,
                userid: Username,
                loginstate: true
            });

            return true;
        }

        this.setState({
            username: null,
            userid: null,
            loginstate: false
        });

        return false;
    };

    promotionlist = () => {
        this.setState({ loading: true });

        instance.post("/api/v1/getpromotion", {
            System: Systems
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    prolistx: Array.isArray(res.data.message) ? res.data.message : []
                }, () => this.openPromotionFromUrl());
            }
        }).catch(async (err) => {
            if (err?.response?.status === 401 || err?.response?.status === 403) {
                localStorage.clear();

                await Swal.fire({
                    title: 'Warning!',
                    text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                    icon: 'warning',
                    confirmButtonText: 'ตกลง'
                });

                window.location.href = '/';
            }
        }).finally(() => {
            this.setState({ loading: false });
        });
    };

    redeempro = async (e, proid) => {
        e.preventDefault();

        var token = localStorage.getItem('auth_token');

        if (token == null) {
            await this.notify("error", 'คุณยังไม่ได้เข้าสู่ระบบ');
            return false;
        }

        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;

        this.setState({
            username: Username
        });

        await instance.post("/api/v1/redeempromotion", {
            userid: Username,
            System: Systems,
            Proid: proid
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    showmodal: false,
                    prodetail: null
                });

                // ลบ promoId ออกจาก URL + รีเฟรชกล่องโปรที่กำลังรับ
                try {
                    const url = new URL(window.location.href);
                    if (url.searchParams.has('promoId')) {
                        url.searchParams.delete('promoId');
                        window.history.pushState({}, '', url.toString());
                    }
                } catch (err) {}

                this.getredeempromotion();

                await this.notify("success", 'รับโปรโมชั่นเรียบร้อย');
            } else if (res.data.status === 201) {
                await this.notify("warning", 'ท่านไม่เข้าเงื่อนไขโปรโมชั่นนี้');
                return false;
            } else if (res.data.status === 204) {
                await this.notify("warning", 'ท่านใช้สิทธิวันนี้ครบแล้ว');
                return false;
            } else if (res.data.status === 202) {
                await this.notify("warning", 'ท่านใช้โปรโมชั่นนี้ไปแล้ว');
                return false;
            } else {
                await this.notify("error", res.data.message || 'ไม่สามารถรับโปรโมชั่นได้');
                return false;
            }
        }).catch(async (err) => {
            if (err?.response?.status === 401 || err?.response?.status === 403) {
                localStorage.clear();

                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
                return false;
            }

            await this.notify("error", 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
        });
    };

    checkpro = async (e, proid) => {
        e.preventDefault();

        var Username = "";
        var token = localStorage.getItem('auth_token');

        if (token == null) {
            await this.notify("error", 'คุณยังไม่ได้เข้าสู่ระบบ');
            return false;
        }

        var decoded = jwt_decode(token);
        Username = decoded.message.playerid;

        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                if (res.data.type === 0) {
                    this.setState({
                        showmodal: true,
                        prodetail: res.data.message.tblpromotions[0],
                        proderedeem: []
                    });
                } else if (res.data.type === 1) {
                    this.setState({
                        showmodal: true,
                        prodetail: null,
                        proderedeem: res.data.message.tblpromotionredeems
                    });
                }
            } else if (res.data.status === 201) {
                this.setState({
                    showmodal: true,
                    prodetail: null,
                    proderedeem: [],
                    picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png"
                });
            } else if (res.data.status === 202) {
                await this.notify("warning", 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย');
                return false;
            }
        }).catch(async (err) => {
            if (err?.response?.status === 401 || err?.response?.status === 403) {
                localStorage.clear();

                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
                return false;
            }

            await this.notify("error", 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
        });
    };

    notify = async (mode, msg) => {
        if (mode === "success") {
            toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored"
            });
        } else if (mode === "warning") {
            toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored"
            });
        } else if (mode === "error") {
            toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored"
            });
        } else {
            toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored"
            });
        }
    };

    getPromotionId = (item) => {
        return (
            item?.Proid ||
            item?.proid ||
            item?.id ||
            item?.ID ||
            item?.promotionid ||
            item?.PromotionId ||
            item?.promotion_id ||
            ""
        );
    };

    // id สำหรับผูก URL ?promoId=X (รองรับ field "no" ที่ API ใช้จริง) — แยกจาก getPromotionId เพื่อไม่กระทบ redeem
    getPromotionUrlId = (item) => {
        const id = this.getPromotionId(item);
        if (id !== "" && id != null) return id;
        if (item && item.no != null) return item.no;
        if (item && item.No != null) return item.No;
        return "";
    };

    getPromotionTitle = (item) => {
        return (
            item?.proname ||
            item?.ProName ||
            item?.title ||
            item?.Title ||
            item?.name ||
            item?.Name ||
            item?.promotionname ||
            item?.PromotionName ||
            "โปรโมชั่น"
        );
    };

    getPromotionDesc = (item) => {
        return (
            item?.shortdetail ||
            item?.shortdesc ||
            item?.desc ||
            item?.description ||
            item?.Description ||
            item?.detail ||
            item?.Detail ||
            "กดดูข้อมูลเพิ่มเติมเพื่ออ่านรายละเอียดโปรโมชั่น"
        );
    };

    getPromotionImage = (item) => {
        return (
            item?.imagepath ||
            item?.imagePath ||
            item?.image ||
            item?.Image ||
            item?.img ||
            item?.img_path ||
            item?.picture ||
            item?.linkpicture ||
            item?.imagesec ||
            this.state.picnonpro
        );
    };

    getPromotionContent = (item) => {
        return (
            item?.content ||
            item?.Content ||
            item?.detail ||
            item?.Detail ||
            item?.description ||
            item?.Description ||
            item?.condition ||
            item?.Condition ||
            ""
        );
    };

    handleJoinClick = async (e, item) => {
        e.preventDefault();

        const isLogin = this.checklogin();

        if (!isLogin) {
            const registerBtn = document.getElementById("registermode");

            if (registerBtn) {
                registerBtn.click();
                return;
            }

            window.location.href = "/register";
            return;
        }

        const proid = this.getPromotionUrlId(item);

        if (proid === "" || proid == null) {
            await this.notify("error", "ไม่พบรหัสโปรโมชั่น");
            return;
        }

        await this.checkpro(e, proid);
    };

    handleInfoClick = async (e, item) => {
        e.preventDefault();

        const proid = this.getPromotionUrlId(item);

        this.setState({
            showmodal: true,
            prodetail: item,
            proderedeem: []
        });

        // ผูก URL ?promoId=X (แบบ bk8) เพื่อให้ refresh / แชร์ลิงก์แล้วยังเปิด detail อยู่
        if (proid !== "" && proid != null) {
            try {
                const url = new URL(window.location.href);
                url.searchParams.set('promoId', proid);
                window.history.pushState({ promoId: proid }, '', url.toString());
            } catch (err) {}
        }
    };

    closePromotionPopup = () => {
        this.setState({
            showmodal: false,
            prodetail: null,
            proderedeem: []
        });

        // ลบ promoId ออกจาก URL ตอนปิด popup
        try {
            const url = new URL(window.location.href);
            if (url.searchParams.has('promoId')) {
                url.searchParams.delete('promoId');
                window.history.pushState({}, '', url.toString());
            }
        } catch (err) {}
    };

    redeemCoupon = async (e) => {
        e.preventDefault();

        const { couponCode } = this.state;
        const code = couponCode.trim();

        if (!code) {
            await this.notify("warning", "กรุณากรอกรหัสคูปอง");
            return;
        }

        const token = localStorage.getItem('auth_token');
        if (!token) {
            await this.notify("error", "คุณยังไม่ได้เข้าสู่ระบบ");
            return;
        }

        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;

        this.setState({ loadingCoupon: true });

        try {
            const res = await instance.post("/api/v1/redeemcoupon", {
                userid: Username,
                System: Systems,
                coupon: code
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (res.data.status === 200) {
                this.setState({ couponCode: '' });
                await this.notify("success", res.data.message || "รับคูปองสำเร็จ");
                this.getredeempromotion();
            } else {
                await this.notify("warning", res.data.message || "รหัสคูปองไม่ถูกต้องหรือหมดอายุแล้ว");
            }
        } catch (err) {
            if (err?.response?.status === 401 || err?.response?.status === 403) {
                localStorage.clear();
                await this.notify("error", "Session ของท่านหมดอายุ กรุณา login ใหม่");
                window.location.href = '/';
                return;
            }
            await this.notify("error", "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        } finally {
            this.setState({ loadingCoupon: false });
        }
    };

    renderCouponInput = () => {
        if (!this.state.loginstate) return null;
        const { couponCode, loadingCoupon } = this.state;

        return (
            <div className="coupon-section">
                <div className="coupon-label">
                    <span className="coupon-icon">🎟️</span>
                    <span>มีรหัสคูปอง?</span>
                </div>
                <form className="coupon-form" onSubmit={this.redeemCoupon}>
                    <input
                        className="coupon-input"
                        type="text"
                        placeholder="กรอกรหัสคูปองของคุณ"
                        value={couponCode}
                        onChange={(e) => this.setState({ couponCode: e.target.value.toUpperCase() })}
                        disabled={loadingCoupon}
                        maxLength={50}
                        autoComplete="off"
                    />
                    <button
                        className="coupon-btn"
                        type="submit"
                        disabled={loadingCoupon || !couponCode.trim()}
                    >
                        {loadingCoupon ? 'กำลังตรวจสอบ...' : 'ใช้คูปอง'}
                    </button>
                </form>

                <style>{`
                    .coupon-section { margin: 0 0 14px; }
                    .coupon-label { display: flex; align-items: center; gap: 6px; color: #8697a2; font-size: 13px; margin-bottom: 8px; }
                    .coupon-icon { font-size: 16px; }
                    .coupon-form { display: flex; gap: 8px; }
                    .coupon-input { flex: 1; border: 1.5px solid #e0e5ea; border-radius: 8px; padding: 10px 14px; font-size: 14px; font-weight: 600; letter-spacing: 1px; color: #1a1a1a; background: #fafbfc; outline: none; transition: border-color .2s; }
                    .coupon-input:focus { border-color: #ff8a00; background: #fff; }
                    .coupon-input::placeholder { color: #b0bac4; font-weight: 400; letter-spacing: 0; }
                    .coupon-input:disabled { opacity: .6; }
                    .coupon-btn { flex: 0 0 auto; background: linear-gradient(135deg, #ff8a00, #ffb347); color: #fff; border: none; border-radius: 8px; padding: 10px 20px; font-size: 14px; font-weight: 700; cursor: pointer; white-space: nowrap; transition: filter .2s; }
                    .coupon-btn:hover:not(:disabled) { filter: brightness(1.06); }
                    .coupon-btn:disabled { opacity: .55; cursor: not-allowed; }
                    @media (max-width: 760px) {
                        .coupon-form { flex-direction: column; }
                        .coupon-btn { width: 100%; padding: 12px; }
                    }
                `}</style>
            </div>
        );
    };

    setActiveTab = (tab) => {
        this.setState({
            activeTab: tab
        });
    };

    getFilteredPromotionList = () => {
        const { prolistx, activeTab } = this.state;

        if (!Array.isArray(prolistx)) return [];

        if (!activeTab || activeTab === "สมาชิกใหม่") {
            return prolistx;
        }

        const keyword = String(activeTab).toLowerCase();

        return prolistx.filter((item) => {
            const title = this.getPromotionTitle(item).toLowerCase();
            const desc = this.getPromotionDesc(item).toLowerCase();
            const type = String(item?.type || item?.Type || item?.category || item?.Category || "").toLowerCase();

            return title.includes(keyword) || desc.includes(keyword) || type.includes(keyword);
        });
    };

    renderTab = (name) => {
        const isActive = this.state.activeTab === name;

        return (
            <li
                className={`tab-wrapper ${isActive ? "active" : ""}`}
                onClick={() => this.setActiveTab(name)}
            >
                <p className={`tab-title ${isActive ? "hover-line" : ""}`}>
                    {name}
                </p>
            </li>
        );
    };

    // แปลง HTML เป็นข้อความล้วน (สำหรับ preview บนการ์ด ไม่ให้โชว์ tag ดิบ)
    stripHtml = (html) => {
        if (!html) return "";
        if (typeof html !== "string") return html;
        try {
            const tmp = document.createElement("div");
            tmp.innerHTML = html;
            return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
        } catch (err) {
            return html.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
        }
    };

    renderPromotionCard = (item, index) => {
        const isLogin = this.state.loginstate;
        const title = this.getPromotionTitle(item);
        const desc = this.stripHtml(this.getPromotionDesc(item));
        const img = this.getPromotionImage(item);

        return (
            <div className="promo-details" key={`${this.getPromotionId(item) || title}-${index}`}>
                <div className="details-wrapper">
                    <img
                        loading="lazy"
                        src={img}
                        className="details-img"
                        alt={title}
                    />

                    <div className="details-data">
                        <div className="details-content">
                            <p className="details-title">{title}</p>

                            <p className="details-desc">
                                {desc}
                            </p>
                        </div>

                        <div className="details-btn">
                            <button
                                className="info-btn"
                                onClick={(e) => this.handleInfoClick(e, item)}
                            >
                                ข้อมูลเพิ่มเติม
                            </button>

                            {isLogin ? (
                                <button
                                    className="apply-btn"
                                    onClick={(e) => this.handleJoinClick(e, item)}
                                >
                                    รับโปร
                                </button>
                            ) : (
                                <button
                                    className="join-btn"
                                    onClick={(e) => this.handleJoinClick(e, item)}
                                >
                                    สมัครสมาชิก
                                </button>
                            )}

                            <div className="share-btn-container">
                                <button
                                    className="share-btn"
                                    onClick={(e) => {
                                        e.preventDefault();

                                        if (navigator.share) {
                                            navigator.share({
                                                title: title,
                                                text: desc,
                                                url: window.location.href
                                            });
                                        } else {
                                            navigator.clipboard?.writeText(window.location.href);
                                            this.notify("success", "คัดลอกลิงก์แล้ว");
                                        }
                                    }}
                                >
                                    แชร์
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderPromotionPopup = () => {
        const { showmodal, prodetail, proderedeem, picnonpro } = this.state;

        if (!showmodal) return null;

        const hasRedeemList = Array.isArray(proderedeem) && proderedeem.length > 0;
        const detail = prodetail || (hasRedeemList ? proderedeem[0] : null);
        const title = detail ? this.getPromotionTitle(detail) : "ไม่พบโปรโมชั่นที่สามารถรับได้";
        const img = detail ? this.getPromotionImage(detail) : picnonpro;
        const content = detail ? this.getPromotionContent(detail) : "ท่านไม่เข้าเงื่อนไขโปรโมชั่นนี้ หรือโปรโมชั่นนี้ไม่สามารถรับได้ในขณะนี้";

        return (
            <div className="ReactModalPortal">
                <div className="ReactModal__Overlay ReactModal__Overlay--after-open standard-popup-overlay promotion-detail-popup-overlay">
                    <div
                        className="ReactModal__Content ReactModal__Content--after-open standard-popup-modal-container promotion-detail-popup-modal-container"
                        tabIndex="-1"
                        role="dialog"
                        aria-modal="true"
                    >
                        <div className="promotion-detail-popup-modal-body">
                            <div
                                className="promotion-detail-close-btn"
                                onClick={this.closePromotionPopup}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 8.81858 8.81858"
                                    className="fillsecond"
                                    width="100%"
                                    height="100%"
                                >
                                    <g className="cross-icon">
                                        <g>
                                            <g>
                                                <path
                                                    className="st0"
                                                    d="M0.26095,8.81701c-0.06982,0-0.13379-0.02734-0.18506-0.07715C-0.01541,8.64806-0.0203,8.4879,0.06857,8.38732l8.3042-8.30566c0.05273-0.05371,0.11426-0.08008,0.18555-0.08008c0.07031,0,0.13477,0.02734,0.18555,0.07813c0.09961,0.10059,0.10059,0.2666-0.00098,0.36719l-8.354,8.3457c0.00049-0.00098,0.00049-0.00098,0-0.00098C0.38449,8.79162,0.33029,8.81701,0.26095,8.81701z"
                                                />
                                                <path
                                                    className="st0"
                                                    d="M8.55832,8.81701c-0.07324,0-0.1377-0.02637-0.18555-0.07422L0.02756,0.38927C-0.0159,0.33849-0.0159,0.17443,0.08224,0.0758c0.0459-0.0459,0.10986-0.07227,0.17871-0.07227c0.06348,0,0.12158,0.02148,0.16309,0.05859l8.31592,8.31055c0.05078,0.0498,0.07715,0.11328,0.07715,0.18457c0,0.07227-0.02637,0.13574-0.0752,0.18457S8.62961,8.81701,8.55832,8.81701z"
                                                />
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>

                            <img
                                loading="lazy"
                                src={img}
                                className="promo-banner"
                                alt={title}
                            />

                            <div className="promo-btn-time" />

                            <div className="promo-detail-title-container">
                                <div className="promo-detail-title">
                                    {title}
                                </div>
                            </div>

                            <div
                                id="promotion-popup2"
                                className="promo-detail-content"
                                dangerouslySetInnerHTML={{
                                    __html: content
                                }}
                            />

                            {detail && (detail.prolist != 5) ? (
                                <div className="promo-popup-action promotion-detail-popup-action">
                                    {this.state.loginstate ? (
                                        <button
                                            className="apply-btn promotion-detail-redeem-btn"
                                            onClick={(e) => this.redeempro(e, this.getPromotionUrlId(detail))}
                                        >
                                            รับโปรโมชั่น
                                        </button>
                                    ) : (
                                        <button
                                            className="apply-btn promotion-detail-register-btn"
                                            onClick={(e) => this.handleJoinClick(e, detail)}
                                        >
                                            สมัคร
                                        </button>
                                    )}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>

                {/* responsive popup เฉพาะมือถือ — แยกจาก desktop */}
                <style>{`
                    @media (max-width: 760px) {
                        .promotion-detail-popup-overlay {
                            display: flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            padding: 0 !important;
                        }
                        .promotion-detail-popup-modal-container {
                            width: 92vw !important;
                            max-width: 92vw !important;
                            min-width: 0 !important;
                            max-height: 88vh !important;
                            inset: auto !important;
                            position: relative !important;
                            margin: 0 auto !important;
                            padding: 0 !important;
                            border-radius: 12px !important;
                            overflow-y: auto !important;
                            overflow-x: hidden !important;
                            -webkit-overflow-scrolling: touch;
                        }
                        .promotion-detail-popup-modal-body {
                            padding: 0 0 16px !important;
                            width: 100% !important;
                        }
                        .promotion-detail-popup-modal-body .promo-banner {
                            width: 100% !important;
                            height: auto !important;
                            display: block !important;
                            border-radius: 12px 12px 0 0 !important;
                        }
                        .promotion-detail-popup-modal-body .promo-detail-title-container {
                            padding: 12px 16px 4px !important;
                        }
                        .promotion-detail-popup-modal-body .promo-detail-title {
                            font-size: 18px !important;
                            font-weight: 700 !important;
                            line-height: 1.3 !important;
                            color: #1a1a1a !important;
                        }
                        .promotion-detail-popup-modal-body .promo-detail-content {
                            padding: 4px 16px !important;
                            font-size: 14px !important;
                            line-height: 1.5 !important;
                            color: #333 !important;
                            word-break: break-word !important;
                        }
                        .promotion-detail-popup-modal-body .promotion-detail-close-btn {
                            width: 22px !important;
                            height: 22px !important;
                            top: 10px !important;
                            right: 10px !important;
                            z-index: 5 !important;
                        }
                        .promotion-detail-popup-action {
                            padding: 8px 16px 4px !important;
                            display: flex !important;
                        }
                        .promotion-detail-popup-action .apply-btn {
                            width: 100% !important;
                            background: #f7a600 !important;
                            color: #fff !important;
                            border: none !important;
                            padding: 12px !important;
                            border-radius: 8px !important;
                            font-size: 15px !important;
                            font-weight: 700 !important;
                            cursor: pointer !important;
                            height: auto !important;
                        }
                    }
                `}</style>
            </div>
        );
    };

    render() {
        const { loading } = this.state;
        const rows = this.getFilteredPromotionList();

        const isMobile = window.innerWidth <= 760;

        /* ─── MOBILE LAYOUT (bk8: tabs + .m-promo-container > .promo-details) — แยกจาก desktop ─── */
        if (isMobile) {
            return (
                <>
                    <ToastContainer />
                    <div className="standard-normal-font-size body-content-container m-promo-page">
                        <div className="header-container">
                            <div className="standard-tab indiana-scroll-container indiana-scroll-container--hide-scrollbars">
                                <ul className="tab-container">
                                    {this.renderTab("สมาชิกใหม่")}
                                    {this.renderTab("กีฬา")}
                                    {this.renderTab("อี สปอร์ต")}
                                    {this.renderTab("คาสิโน")}
                                    {this.renderTab("สล็อต")}
                                    {this.renderTab("ยิงปลา")}
                                    {this.renderTab("VIP")}
                                    {this.renderTab("พิเศษ")}
                                    {this.renderTab("ล็อตเตอรี่")}
                                </ul>
                            </div>
                        </div>
                        <div className="m-promo-container">
                            {this.renderActivePromotion()}
                            {this.renderCouponInput()}
                            {loading ? (
                                <div className="promo-details"><div className="details-wrapper"><div className="details-data"><div className="details-content"><p className="details-title">กำลังโหลดโปรโมชั่น...</p></div></div></div></div>
                            ) : rows.length > 0 ? (
                                rows.map((item, index) => this.renderPromotionCard(item, index))
                            ) : (
                                <div className="promo-details"><div className="details-wrapper"><div className="details-data"><div className="details-content"><p className="details-title">ไม่พบโปรโมชั่น</p></div></div></div></div>
                            )}
                        </div>
                    </div>
                    <style>{`
                        /* พื้นหลังขาวทั้งหน้า */
                        .m-promo-page { background: #ffffff !important; min-height: 100vh; }
                        .m-promo-page .m-promo-container { background: #ffffff !important; padding: 10px 12px; }
                        /* แท็บหมวดแนวนอนเลื่อนได้ + พื้นขาว */
                        .m-promo-page .header-container { background: #ffffff !important; border-bottom: 1px solid #eee; }
                        .m-promo-page .standard-tab { background: #ffffff !important; }
                        .m-promo-page .standard-tab .tab-container { display: flex !important; flex-direction: row !important; flex-wrap: nowrap !important; overflow-x: auto !important; gap: 2px; padding: 4px 10px; margin: 0; list-style: none; }
                        .m-promo-page .tab-wrapper { flex: 0 0 auto !important; white-space: nowrap; padding: 10px 12px; cursor: pointer; border-bottom: 2px solid transparent; }
                        .m-promo-page .tab-wrapper .tab-title { color: #8697a2; font-size: 14px; margin: 0; }
                        .m-promo-page .tab-wrapper.active { border-bottom-color: #ff8a00; }
                        .m-promo-page .tab-wrapper.active .tab-title, .m-promo-page .tab-title.hover-line { color: #1a1a1a; font-weight: 700; }
                        /* การ์ด */
                        .m-promo-container .promo-details { background: #fff; border-radius: 10px; overflow: hidden; margin: 0 0 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); }
                        .m-promo-container .details-wrapper { display: flex !important; flex-direction: column !important; width: 100% !important; }
                        .m-promo-container .details-img { width: 100% !important; height: auto !important; object-fit: cover !important; display: block !important; }
                        .m-promo-container .details-data { width: 100% !important; max-width: none !important; padding: 10px 12px 12px !important; }
                        .m-promo-container .details-title { color: #1a1a1a; font-weight: 700; font-size: 16px; }
                        .m-promo-container .details-desc { color: #6b7280; font-size: 13px; }
                        /* ปุ่ม: ข้อมูลเพิ่มเติม (น้ำเงิน) + แชร์ (เทา) — ซ่อน รับโปร */
                        .m-promo-container .details-btn { display: flex !important; gap: 8px !important; margin-top: 10px !important; align-items: stretch !important; }
                        .m-promo-container .details-btn .info-btn { flex: 1 !important; background: #0071e3 !important; color: #fff !important; border: none !important; padding: 12px 8px !important; border-radius: 8px !important; font-size: 14px !important; font-weight: 600 !important; cursor: pointer; height: auto !important; }
                        .m-promo-container .details-btn .apply-btn { display: none !important; }
                        .m-promo-container .details-btn .share-btn-container { flex: 1 !important; height: auto !important; }
                        .m-promo-container .details-btn .share-btn { width: 100% !important; background: #b8bcc4 !important; color: #fff !important; border: none !important; padding: 12px 8px !important; border-radius: 8px !important; font-size: 14px !important; font-weight: 600 !important; cursor: pointer; }
                    `}</style>
                    {this.renderPromotionPopup()}
                </>
            );
        }

        return (
            <>
                <ToastContainer />

                <div className="promo-container">
                    <div className="header-container">
                        <div className="standard-tab indiana-scroll-container indiana-scroll-container--hide-scrollbars">
                            <ul className="tab-container">
                                {this.renderTab("สมาชิกใหม่")}
                                {this.renderTab("กีฬา")}
                                {this.renderTab("อี สปอร์ต")}
                                {this.renderTab("คาสิโน")}
                                {this.renderTab("สล็อต")}
                                {this.renderTab("ยิงปลา")}
                                {this.renderTab("VIP")}
                                {this.renderTab("พิเศษ")}
                                {this.renderTab("ล็อตเตอรี่")}
                            </ul>
                        </div>
                    </div>

                    <div className="content-container">
                        {this.renderActivePromotion()}
                        {this.renderCouponInput()}
                        <div className="content-wrapper">
                            {loading ? (
                                <div className="promo-details">
                                    <div className="details-wrapper">
                                        <div className="details-data">
                                            <div className="details-content">
                                                <p className="details-title">กำลังโหลดโปรโมชั่น...</p>
                                                <p className="details-desc">กรุณารอสักครู่</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : rows.length > 0 ? (
                                rows.map((item, index) => this.renderPromotionCard(item, index))
                            ) : (
                                <div className="promo-details">
                                    <div className="details-wrapper">
                                        <div className="details-data">
                                            <div className="details-content">
                                                <p className="details-title">ไม่พบโปรโมชั่น</p>
                                                <p className="details-desc">
                                                    ยังไม่มีโปรโมชั่นในหมวดนี้
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {this.renderPromotionPopup()}

                <style>
                    {`
                        .promo-popup-action {
                            position: sticky;
                            bottom: 0;
                            padding: 14px 0 4px;
                            background: linear-gradient(to top, #fff 70%, rgba(255,255,255,0));
                            display: flex;
                            justify-content: center;
                            z-index: 2;
                        }

                        .promo-popup-claim-btn {
                            width: 100%;
                            max-width: 320px;
                            height: 44px;
                            border: none;
                            border-radius: 999px;
                            background: linear-gradient(135deg, #ff8a00, #ffb347);
                            color: #fff;
                            font-size: 16px;
                            font-weight: 900;
                            cursor: pointer;
                            box-shadow: 0 8px 22px rgba(255, 138, 0, .32);
                        }

                        .promo-popup-claim-btn:hover {
                            filter: brightness(1.05);
                        }

                        .apply-btn {
                            border: none;
                            border-radius: 999px;
                            background: linear-gradient(135deg, #ff8a00, #ffb347);
                            color: #fff;
                            font-weight: 800;
                            cursor: pointer;
                        }

                        .join-btn {
                            border: none;
                            border-radius: 999px;
                            background: linear-gradient(135deg, #111827, #374151);
                            color: #fff;
                            font-weight: 800;
                            cursor: pointer;
                        }
                    `}
                </style>
            </>
        );
    }
}

export default App;